import React, { useRef, useState, useEffect } from 'react'
import SignatureCanvas from 'react-signature-canvas'
import PropTypes from 'prop-types'

const SignatureComponent = ({ initialValue, onSave, penColor = 'black' }) => {
  const sigPad = useRef(null)

  const [isEditing, setIsEditing] = useState(!initialValue)

  useEffect(() => {
    if (initialValue) {
      setIsEditing(false)
    }
  }, [initialValue])

  const handleClear = () => {
    setIsEditing(false)
  }

  const handleAction = () => {
    if (sigPad.current.isEmpty()) {
      alert('Please provide a signature first.')
      return
    }

    const canvas = sigPad.current.getCanvas()
    canvas.toBlob((blob) => {
      onSave(blob)
      setIsEditing(false)
    }, 'image/png')
  }

  return (
    <div style={{ width: '100%', maxWidth: '500px', marginBottom: '20px' }}>
      <label
        style={{ display: 'block', marginBottom: '8px' }}
        className='font-medium text-gray'
      >
        Signature
      </label>

      <div
        style={{
          position: 'relative',
          border: '1px solid #d9d9d9',
          borderRadius: '8px',
          background: '#fff',
          minHeight: '180px',
        }}
      >
        {isEditing ? (
          <>
            <SignatureCanvas
              ref={(ref) => {
                sigPad.current = ref
              }}
              penColor={penColor}
              canvasProps={{
                className: 'sigCanvas',
                style: { width: '100%', height: '180px', display: 'block' },
              }}
            />

            <div
              style={{
                padding: '10px',
                borderTop: '1px solid #eee',
                display: 'flex',
                justifyContent: 'flex-end',
                gap: '10px',
                background: '#f9f9f9',
              }}
            >
              <button
                type='button'
                onClick={handleClear}
                style={btnDanger}
                className='transition-transform duration-200 hover:!bg-primary hover:!text-white active:scale-95'
              >
                Cancel
              </button>

              <button
                type='button'
                onClick={handleAction}
                style={btnPrimary}
                className='bg-primary transition-transform duration-200 text-white hover:bg-transparent hover:text-primary hover:border hover:border-primary border'
              >
                Submit
              </button>
            </div>
          </>
        ) : (
          <div style={{ padding: '20px', textAlign: 'center' }}>
            <button
              type='button'
              onClick={() => setIsEditing(true)}
              style={editButtonStyle}
            >
              Edit
            </button>
            {initialValue && (
              <img
                src={initialValue}
                alt='Current Signature'
                style={{
                  maxHeight: '120px',
                  maxWidth: '100%',
                  objectFit: 'contain',
                }}
              />
            )}
          </div>
        )}
      </div>
    </div>
  )
}

const btnPrimary = {
  padding: '8px 20px',
  cursor: 'pointer',
  borderRadius: '4px',
}
const btnDanger = {
  padding: '8px 16px',
  cursor: 'pointer',
  backgroundColor: 'transparent',
  color: '#ff4d4f',
  border: '1px solid #ff4d4f',
  borderRadius: '4px',
}
const editButtonStyle = {
  position: 'absolute',
  top: '10px',
  right: '10px',
  padding: '4px 12px',
  fontSize: '12px',
  cursor: 'pointer',
  backgroundColor: '#f0f0f0',
  border: '1px solid #d9d9d9',
  borderRadius: '4px',
  zIndex: 10,
}

SignatureComponent.propTypes = {
  initialValue: PropTypes.string,
  onSave: PropTypes.func.isRequired,
  penColor: PropTypes.string,
}

export default SignatureComponent
